﻿"use strict";
export function changeCompany() {
    // company change
    jQuery(".profile-companies").click(function (e) {
        e.preventDefault();

        //var body = jQuery("body");
        var modal_name = "profile-companiesList";
        var modal_title = 'Выберите компанию';
        var modal_form = '<div class="modal fade" id="' + modal_name + '" tabindex="-1" role="dialog" aria-labelledby="' + modal_name + 'Label" aria-hidden="true">' +
            '<div class="modal-dialog" role="document">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<h5 class="modal-title" id="' + modal_name + 'Label">' + modal_title + '</h5>' +
            '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
            '<span aria-hidden="true">&times;</span>' +
            '</button>' +
            '</div>' +
            '<div class="modal-body">' +
            '<div class="d-flex justify-content-center">' +
            '<div class="spinner-border m-3" role="status" style="width: 4rem; height: 4rem;">' +
            '<span class="sr-only">Loading...</span>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        jQuery("body").append(modal_form);

        jQuery("#" + "profile-companiesList").modal("show");
    });
    jQuery("body").on("shown.bs.modal", "#" + "profile-companiesList", function () {
        jQuery.ajax({
            method: "POST",
            url: '/Template/MainLayout2_companies.cshtml',
            data: {
                company_change: "change"
            },
            success: function (response) {
                jQuery(".modal-body").html(response);
            },
            error: function (error) {
                jQuery(".modal-body").html(error);
            }
        });
    });
    jQuery("body").on("hidden.bs.modal", "#" + "profile-companiesList", function () {
        jQuery("#" + "profile-companiesList").remove();
    });
}